/*
 * Aether scroll states (R99, run 33, 26 Oct).
 * Horizon scrolls .page-wrapper on desktop (>= 990px) and the document below that, so CSS
 * scroll(root) timelines never move on desktop. This script reads whichever container is
 * scrolling and sets two attributes on <html>:
 *   data-ah-lifted  the page has moved; the header's hairline fades in (aether-k-v33.css).
 *   data-ah-tucked  long reads only (essays, Story, chapter pages): reading down past two header heights slides the header away;
 *                   any upward scroll, focus in the header, an open menu or drawer brings it back.
 * Without this script the header simply stays put with no hairline. Reduced motion: never tucks.
 */
(function () {
  'use strict';
  var root = document.documentElement;
  var squeeze = window.matchMedia('(min-width: 990px)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var header = null;
  var section = null;
  var wrapper = null;
  var tuckable = false;
  var headerHeight = 64;
  var anchor = 0;
  var queued = false;

  function container() {
    if (squeeze.matches && wrapper) return wrapper;
    return document.scrollingElement || root;
  }

  function busy() {
    if (root.hasAttribute('scroll-lock')) return true;
    if (!header) return true;
    if (header.contains(document.activeElement) && document.activeElement !== document.body) return true;
    return !!header.querySelector('[aria-expanded="true"], details[open], .menu-list__submenu:not([inert])');
  }

  function untuck() {
    if (root.hasAttribute('data-ah-tucked')) root.removeAttribute('data-ah-tucked');
  }

  function update() {
    queued = false;
    var y = container().scrollTop;
    if ((y > 4) !== root.hasAttribute('data-ah-lifted')) root.toggleAttribute('data-ah-lifted', y > 4);
    if (!tuckable || calm.matches) {
      untuck();
      anchor = y;
      return;
    }
    var moved = y - anchor;
    if (y < Math.max(headerHeight * 2, 160) || busy()) {
      untuck();
      anchor = y;
    } else if (moved > 8) {
      root.setAttribute('data-ah-tucked', '');
      anchor = y;
    } else if (moved < -8) {
      untuck();
      anchor = y;
    }
  }

  function onScroll(event) {
    var t = event.target;
    if (t !== document && t !== root && t !== wrapper) return;
    if (!queued) {
      queued = true;
      window.requestAnimationFrame(update);
    }
  }

  function measure() {
    if (section) headerHeight = section.offsetHeight || headerHeight;
  }

  function init() {
    header = document.getElementById('header-component');
    section = header ? header.closest('.header-section') || header.parentElement : null;
    wrapper = document.querySelector('.page-wrapper');
    // Long reads: essays (.aart), the Story page (.astory) and chapter pages (.ach). Run 34 added the last two (R101).
    tuckable = !!document.querySelector('.aart, .astory, .ach') && !!section;
    measure();
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', function () { measure(); update(); }, { passive: true });
    document.addEventListener('focusin', function (event) {
      if (header && header.contains(event.target)) untuck();
    });
    if (squeeze.addEventListener) squeeze.addEventListener('change', update);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();